import { Component, OnInit } from '@angular/core';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';
import { SubscriptionFacadeService } from '@app/forms/subscription/services/subscription-facade.service';
import { EaSubscriptionBuilder } from './ea-subscription-form.builder';
import { lmnpFiscalLawChoices } from '../lmnp-fiscal-law-options';

@Component({
    selector: 'real-estate-fiscal-law',
    templateUrl: './real-estate-fiscal-law.component.html',
    styleUrls: ['./real-estate-fiscal-law.component.scss'],
    standalone: false
})
export class RealEstateFiscalLawComponent
  extends EaSubscriptionBuilder
  implements OnInit
{
  optionsUnfurnished = [
    {
      value: 'FONCIER',
      label: 'Régime foncier',
      suffix: { title: 'A' },
    },
    { value: 'MICRO_FONCIER', label: 'Micro-foncier', suffix: { title: 'B' } },
    {
      value: 'PINEL',
      label: 'Pinel',
      suffix: { title: 'C' },
    },
    {
      value: 'PINEL_DOMTOM',
      label: 'Pinel DOM-TOM',
      suffix: { title: 'D' },
    },
    {
      value: 'MALRAUX',
      label: 'Malraux ZPPAUP',
      suffix: { title: 'E' },
    },
    {
      value: 'MALRAUX_SECTEUR_SAUVE',
      label: 'Malraux secteur sauvegardé',
      suffix: { title: 'F' },
    },
    {
      value: 'MONUMENT_HISTO',
      label: 'Monument historique',
      suffix: { title: 'G' },
    },
    {
      value: 'BORLOO',
      label: 'Borloo',
      suffix: { title: 'H' },
    },
    {
      value: 'DEFICITE_FONCIER',
      label: 'Déficit foncier',
      suffix: { title: 'I' },
    },
    {
      value: 'DUFLOT',
      label: 'Duflot',
      suffix: { title: 'J' },
    },
    {
      value: 'DENORMANDIE',
      label: 'Denormandie',
      suffix: { title: 'K' },
    },
    {
      value: 'ROBIEN',
      label: 'Robien',
      suffix: { title: 'L' },
    },
    {
      value: 'SCELLIER',
      label: 'Scellier',
      suffix: { title: 'M' },
    },
  ];

  optionsLmnp = lmnpFiscalLawChoices;

  get options() {
    const firstProduct = this.products?.controls?.[0];
    if (firstProduct) {
      const type = firstProduct.get('parameters.type')?.value;
      if (type === 'UNFURNISHED') {
        return this.optionsUnfurnished;
      } else if (type === 'LMNP') {
        return this.optionsLmnp;
      }
    }
    return [];
  }

  constructor(
    protected formConstructor: PrFormConstructor,
    private subscriptionFacade: SubscriptionFacadeService,
  ) {
    super(formConstructor);
  }

  ngOnInit() {
    this.subscriptionFacade.initForm(this);
  }

  onSubmit() {
    this.form.markAsDirty();

    this.subscriptionFacade.submitPledge(this);
  }

  prev() {
    this.subscriptionFacade.previousStep();
  }
}
